export const ERROR_EMAIL_INVALID = '⛔ Email is invalid'
// export const ERROR_EMAIL_NOT_APPROVED = 'Email is invalid'
export const ERROR_FAILED_TO_CACHE = (itemName: string) => `Failed to cache ${itemName}`